export const productMedia = {
  UP1: [
    {
      type: 'image',
      subtype: 'featured_image',
      url: 'https://uploads.actionvfx.com/attachment/743830/Product_Media_-_Underwater_Particles_-_Title.jpg'
    },
    {
      type: 'image',
      subtype: 'features',
      url: 'https://uploads.actionvfx.com/attachment/743829/Product_Media_-_Underwater_Particles_-_Features.jpg'
    },
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: 'R774pAm94fk'
    }
  ],
  UB1: [
    {
      type: 'image',
      subtype: 'featured_image',
      url: 'https://uploads.actionvfx.com/attachment/743833/Product_Media_-_Underwater_Bubbles_-_Title.jpg'
    },
    {
      type: 'image',
      subtype: 'features',
      url: 'https://uploads.actionvfx.com/attachment/743834/Product_Media_-_Underwater_Bubbles_-_Features.jpg'
    },
    {
      type: 'image',
      subtype: 'features',
      url: '/img/products/Product-Media---Underwater-Bubbles---Frame-Rate.gif'
    },
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: 'gegTG1xY1LY'
    }
  ],
  PF0001: [
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: 'HA_7nt6ockQ'
    }
  ],
  PF0031: [
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: 'bRTRCLubp3c'
    }
  ],
  PF0085: [
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: 'ZrITOYV63Ok'
    }
  ],
  PF0087: [
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: 'vqrKiijgioI'
    }
  ],
  PF0098: [
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: 'RZWfILeDWqE'
    }
  ],
  PF0099: [
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: 'BU-J5wOynJA'
    }
  ],
  PAF1: [
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: 'PMtQreaxSAY'
    },
    {
      type: 'image',
      subtype: 'featured_image',
      url: 'https://s3.amazonaws.com/uploads.actionvfx.com/product_media/Foliage_Still.png'
    },
    {
      type: 'image',
      subtype: 'features',
      url: 'https://s3.amazonaws.com/uploads.actionvfx.com/product_media/Lighting_Cycle_GIF.gif'
    },
    {
      type: 'image',
      subtype: 'featured_image',
      url: 'https://uploads.actionvfx.com/attachment/757222/Plants_and_Foliage_Vol.1.jpg'
    }
  ],
  WTAP1: [
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: '7YDxbooGd4A'
    },
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: '_vNg40BzZF8'
    },
    {
      type: 'youtube',
      subtype: 'vfx_shot',
      url: 'J_m9KhTkZTk'
    },
    {
      type: 'image',
      subtype: 'featured_image',
      url: 'https://uploads.actionvfx.com/attachment/757221/Windy_Trash___Paper.jpg'
    }
  ]
};
